import {
  getAxiosOrganizationRequest,
  postAxiosCreateOrganizationRequest,
} from "@API";
import {
  createGetOrganizationsInterceptors,
  createPostCreateOrganizationRequestInterceptors,
} from "@API/Organizations/middlewares";
import {
  IAxiosOrganization,
  IGetAxiosOrganizations,
  IPostAxiosOrganization,
  NewOrganizationPayload,
} from "@API/Organizations/types";
import { IOrganization } from "@Store/Organizations/types";
import { AxiosInstance, AxiosResponse } from "axios";

export const getAxiosOrganizations =
  async (): Promise<IGetAxiosOrganizations> => {
    const organizationsRequest: AxiosInstance = getAxiosOrganizationRequest();

    createGetOrganizationsInterceptors(organizationsRequest);

    const response: AxiosResponse = await organizationsRequest.get("");

    const organizationsData: IOrganization[] = response.data;

    return { data: organizationsData };
  };

export const putAxiosOrganization = async (
  payload: IOrganization
): Promise<IAxiosOrganization> => {
  // const response = await getApiRequest().put(`/organizations/${payload.id}/`, formatBody(payload));

  return { data: payload };
};

export const postAxiosCreateOrganization = async (
  payload: NewOrganizationPayload
): Promise<IPostAxiosOrganization> => {
  const createOrganizationRequest: AxiosInstance =
    postAxiosCreateOrganizationRequest();

  createPostCreateOrganizationRequestInterceptors(createOrganizationRequest);

  const response: AxiosResponse = await createOrganizationRequest.post(
    "",
    payload
  );

  const newOrganizationData: IOrganization = response.data;

  return { data: newOrganizationData };
};

export const deleteAxiosOrganization = async (payload: number): Promise<{}> => {
  // await getApiRequest().delete(`/organizations/${payload}`));

  return {};
};
